// import charcoal_serika from '../DynamicPage/vanagonR4/img/charcoal_serika.jpeg'

const data:any = [
];

export default data;
